import React, { useState, useEffect } from 'react';
import { Button } from '@andes/button';
import classNames from 'classnames';
import { Section, Typography, EshopsComponentsTitles, Action } from '@mshops-components-library/common';
import { v4 } from 'uuid';
import { ItemDesktop, ItemMobile } from '@mshops-components-library/item';
import EshopItem from '@mshops-components-library/eshop-item';
var REACT_ELEMENT_TYPE$1;
function _createRawReactElement$1(e, r, E, l) {
  REACT_ELEMENT_TYPE$1 || (REACT_ELEMENT_TYPE$1 = "function" == typeof Symbol && Symbol["for"] && Symbol["for"]("react.element") || 60103);
  var o = e && e.defaultProps,
    n = arguments.length - 3;
  if (r || 0 === n || (r = {
    children: void 0
  }), 1 === n) r.children = l;else if (n > 1) {
    for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];
    r.children = t;
  }
  if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});
  return {
    $$typeof: REACT_ELEMENT_TYPE$1,
    type: e,
    key: void 0 === E ? null : "" + E,
    ref: null,
    props: r,
    _owner: null
  };
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _defineProperty(e, r, t) {
  return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
var TYPES = {
  SELLER: 'seller',
  SUPER: 'super',
  SUPER_PARTNER: 'super_partner',
  BRAND: 'brand',
  DEFAULT: 'eshop',
  LANDING: 'landing'
};
var VARIANTS_BUTTONS = {
  NEUTRAL: 'neutral',
  SECONDARY: 'secondary'
};
var VAR_CSS = {
  VAR_BUTTON_NEUTRAL_IDLE_COLOR: 'var(--button-neutral-idle-color, var(--colorTextVar))',
  VAR_COLOR_OR_BLACK_BY_PRIMARY_COLOR: 'var(--colorOrBlackByPrimaryColor)',
  VAR_PRIMARY_TEXT_COLOR_VAR: 'var(--primaryTextColorVar)'
};
var ANDES_BLUE_500 = '#3483FA';
var constants = {
  TYPES: TYPES,
  VARIANTS_BUTTONS: VARIANTS_BUTTONS,
  VAR_CSS: VAR_CSS,
  ANDES_BLUE_500: ANDES_BLUE_500
};
var ESHOPS_ACTION_CHEVRON = [constants.TYPES.SUPER, constants.TYPES.SUPER_PARTNER];
var ESHOPS_WITH_ESHOSITEMS = [constants.TYPES.SELLER, constants.TYPES.SUPER, constants.TYPES.DEFAULT, constants.TYPES.SUPER_PARTNER, constants.TYPES.BRAND, constants.TYPES.LANDING];
var ESHOPS_WITHOUT_CARDACTIONS = [constants.TYPES.SELLER, constants.TYPES.BRAND, constants.TYPES.LANDING];
var ESHOPS = [constants.TYPES.DEFAULT, constants.TYPES.SELLER, constants.TYPES.SUPER, constants.TYPES.SUPER_PARTNER, constants.TYPES.BRAND, constants.TYPES.LANDING];
var EXPLORER_THEME = 'explorer';
var LEGEND_THEME = 'legend';
var namespace$1 = 'ui-ms-products-gallery';
var RecommendationsContainer$2 = function RecommendationsContainer(_ref) {
  var _h, _Typography;
  var children = _ref.children,
    display = _ref.display,
    highlightSeeds = _ref.highlight_seeds,
    title = _ref.title,
    type = _ref.type,
    categories = _ref.categories,
    showTitle = _ref.show_title,
    eshopType = _ref.eshopType,
    deviceType = _ref.deviceType,
    isPolycard = _ref.isPolycard,
    isEditable = _ref.isEditable,
    elementsAlignment = _ref.elements_alignment,
    isCustomHtml = _ref.isCustomHtml;
  var hasCategory = Boolean(categories === null || categories === void 0 ? void 0 : categories.length);
  var isEshopType = ESHOPS.includes(eshopType);
  var isMobile = deviceType === 'mobile';
  var sectionHeaderClassName = classNames('section-header-products-gallery', "section-header section-header__".concat(display), {
    'section-header__title-container': hasCategory
  });
  var rowContainerClassName = classNames('row container ui-ms-products-gallery__container', {
    'highlight-seeds': highlightSeeds
  });
  var categoriesClassName = classNames("ui-ms-products-gallery-section \n    ui-ms-products-gallery-section--".concat(deviceType), _defineProperty({
    'section-center': hasCategory,
    'ui-ms-section-eshops': isEshopType,
    'ui-ms-section-eshops--seller': eshopType === 'seller' || eshopType === 'brand' || eshopType === 'landing',
    'ui-ms-products-gallery__polycard': isPolycard,
    'ui-ms-products-gallery__polycard--editable': isEditable && isPolycard
  }, "ui-ms-products-gallery-section--".concat(elementsAlignment, " "), elementsAlignment));
  var eshopContainerClassName = classNames('section-eshop__title--layout', {
    'section-eshop__title': hasCategory
  });
  var childrenContainerClassName = classNames('ui-ms-products-gallery__children-container', {
    'ui-ms-products-gallery__children-container--mobile': isMobile
  });
  var titleClassName = classNames('products-gallery-title', 'section-header__title--base', {
    'section-header__title': hasCategory
  });
  var titleSizeBasedOnDevice = deviceType === 'mobile' ? 'small' : 'medium';
  var isEshopsOrCustomHTML = isEshopType || isCustomHtml;
  var renderTitle = function renderTitle() {
    if (isEshopsOrCustomHTML) {
      return _h || (_h = /*#__PURE__*/_createRawReactElement$1("h2", {
        className: titleClassName
      }, void 0, title));
    }
    return _Typography || (_Typography = /*#__PURE__*/_createRawReactElement$1(Typography, {
      type: "title",
      size: titleSizeBasedOnDevice,
      weight: "bold",
      className: "".concat(namespace$1, "__title")
    }, void 0, title));
  };
  return /*#__PURE__*/_createRawReactElement$1(Section, {
    type: type,
    className: categoriesClassName,
    eshopType: eshopType
  }, void 0, /*#__PURE__*/_createRawReactElement$1("div", {
    className: rowContainerClassName
  }, void 0, /*#__PURE__*/_createRawReactElement$1("div", {
    className: isEshopType ? eshopContainerClassName : sectionHeaderClassName
  }, void 0, showTitle && renderTitle()), /*#__PURE__*/_createRawReactElement$1("div", {
    className: childrenContainerClassName
  }, void 0, children)));
};
RecommendationsContainer$2.defaultProps = {
  display: 'original',
  highlight_seeds: false,
  view_more_action: null,
  show_title: true,
  eshopType: '',
  type: '',
  withoutTabsCategory: false,
  categories: [],
  isPolycard: false,
  isEditable: false
};
var RecommendationsContainer$3 = RecommendationsContainer$2;
const ProductsGalleryV3 = /*#__PURE__*/function () {
  const ProductsGalleryV3 = function ProductsGalleryV3(props) {
    var children = props.children,
      actionButton = props.action_button;
    return /*#__PURE__*/React.createElement(RecommendationsContainer$3, props, children, actionButton && /*#__PURE__*/_createRawReactElement$1(Button, {
      id: actionButton.id,
      className: "grid-recommendations-button",
      href: actionButton.target
    }, void 0, actionButton.label));
  };
  ProductsGalleryV3.defaultProps = {
    children: [],
    action_button: null
  };
  return ProductsGalleryV3;
}();
var ProductsGalleryV3$1 = ProductsGalleryV3;
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
var REACT_ELEMENT_TYPE;
function _createRawReactElement(e, r, E, l) {
  REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);
  var o = e && e.defaultProps,
    n = arguments.length - 3;
  if (r || 0 === n || (r = {
    children: void 0
  }), 1 === n) r.children = l;else if (n > 1) {
    for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];
    r.children = t;
  }
  if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});
  return {
    $$typeof: REACT_ELEMENT_TYPE,
    type: e,
    key: void 0 === E ? null : "" + E,
    ref: null,
    props: r,
    _owner: null
  };
}
const Asset$1 = _ref => {
  let {
    color = "rgba(0, 0, 0, 0.9)",
    i18n: i18n,
    srLabel: srLabel
  } = _ref;
  return _createRawReactElement("svg", {
    "aria-hidden": srLabel ? void 0 : !srLabel,
    "aria-label": srLabel || void 0,
    role: srLabel ? "img" : void 0,
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: color
  }, void 0, srLabel && _createRawReactElement("title", {}, void 0, srLabel), _createRawReactElement("path", {
    d: "M8.27686 4.34644L7.42834 5.19496L12.224 9.99059L7.42334 14.7912L8.27187 15.6397L13.921 9.99059L8.27686 4.34644Z",
    fill: color
  }));
};
const Asset = _ref => {
  let {
    color = "rgba(0, 0, 0, 0.9)",
    i18n: i18n,
    srLabel: srLabel
  } = _ref;
  return _createRawReactElement("svg", {
    "aria-hidden": srLabel ? void 0 : !srLabel,
    "aria-label": srLabel || void 0,
    role: srLabel ? "img" : void 0,
    width: "12",
    height: "12",
    viewBox: "0 0 12 12",
    fill: color
  }, void 0, srLabel && _createRawReactElement("title", {}, void 0, srLabel), _createRawReactElement("path", {
    d: "M4.89779 1.85229L4.10229 2.64779L7.45455 6.00004L4.10229 9.35229L4.89779 10.1478L9.04554 6.00004L4.89779 1.85229Z",
    fill: color
  }));
};
var VALID_ESHOP_TYPES = ['seller', 'affiliate', 'brand'];
var typeEshop = function typeEshop(eshopType) {
  return Boolean(eshopType && VALID_ESHOP_TYPES.includes(eshopType));
};
var TabsList$1 = function TabsList(_ref) {
  var tabs = _ref.tabs,
    activeTab = _ref.activeTab,
    handleTabs = _ref.handleTabs,
    layoutTheme = _ref.layoutTheme;
  return /*#__PURE__*/_createRawReactElement$1("ul", {
    className: "carousel-with-tabs__tabs-list products-gallery-with-tabs__tabs-list"
  }, void 0, tabs === null || tabs === void 0 ? void 0 : tabs.map(function (tab) {
    var isTabActive = activeTab === tab.id && tabs.length > 1;
    var tabClasses = classNames('tabs-list__item', {
      'tabs-list__item--without-underline': tabs.length === 1,
      'tabs-list__item--active': isTabActive,
      'header--custom-background': isTabActive && layoutTheme === 'explorer'
    });
    var tabLabelClasses = classNames('tab-item-label', {
      'header--custom-text': isTabActive && layoutTheme === 'explorer'
    });
    if (tab.items.length === 0) {
      return null;
    }
    return /*#__PURE__*/_createRawReactElement$1("li", {
      className: tabClasses,
      id: tab.id,
      onClick: function onClick(event) {
        return handleTabs(event, tab.id);
      },
      role: "button",
      tabIndex: "-1"
    }, v4(), /*#__PURE__*/_createRawReactElement$1("div", {
      className: tabLabelClasses
    }, void 0, tab.label));
  }));
};
TabsList$1.defaultProps = {
  layoutTheme: '',
  handleTabs: function handleTabs() {},
  activeTab: '',
  tabs: []
};
var TabsList$2 = TabsList$1;
var TabsListComponent = function TabsListComponent(_ref) {
  var tabs = _ref.tabs,
    type = _ref.type,
    layoutTheme = _ref.layoutTheme,
    handleTabs = _ref.handleTabs,
    activeTabId = _ref.activeTabId;
  return /*#__PURE__*/_createRawReactElement$1(Section, {
    type: type,
    className: "products-gallery-section"
  }, void 0, /*#__PURE__*/_createRawReactElement$1("div", {
    className: "row container carousel-with-tabs products-gallery-container"
  }, void 0, /*#__PURE__*/_createRawReactElement$1("div", {
    className: "section-header products-gallery-with-tabs"
  }, void 0, (tabs === null || tabs === void 0 ? void 0 : tabs.length) > 1 && /*#__PURE__*/_createRawReactElement$1(TabsList$2, {
    tabs: tabs,
    layoutTheme: layoutTheme,
    activeTab: activeTabId,
    handleTabs: handleTabs
  }))));
};
TabsListComponent.defaultProps = {
  layoutTheme: '',
  handleTabs: function handleTabs() {},
  activeTab: '',
  tabs: []
};
var TabsList = TabsListComponent;
var _ChevronRight, _Fragment, _ChevronRight2;
var namespace = 'products-gallery';
const RecommendationsContainer = /*#__PURE__*/function () {
  const RecommendationsContainer = function RecommendationsContainer(_ref) {
    var _categories$, _EshopsComponentsTitl, _h;
    var children = _ref.children,
      display = _ref.display,
      highlightSeeds = _ref.highlight_seeds,
      title = _ref.title,
      type = _ref.type,
      viewMoreAction = _ref.view_more_action,
      categories = _ref.categories,
      updateGrid = _ref.updateGrid,
      showTitle = _ref.show_title,
      eshopType = _ref.eshopType,
      deviceType = _ref.deviceType,
      withoutTabsCategory = _ref.withoutTabsCategory,
      layoutTheme = _ref.layoutTheme,
      isEshops = _ref.isEshops,
      isPolycard = _ref.isPolycard,
      isEditable = _ref.isEditable,
      trackingId = _ref.trackingId;
    var hasCategory = Boolean(categories === null || categories === void 0 ? void 0 : categories.length);
    var isEshopType = ESHOPS.includes(eshopType);
    var usingChevron = ESHOPS_ACTION_CHEVRON.includes(eshopType);
    var showViewMoreAction = isEshopType || !hasCategory;
    var newViewMoreAction = isEshopType ? categories === null || categories === void 0 || (_categories$ = categories[0]) === null || _categories$ === void 0 ? void 0 : _categories$.view_more_action : viewMoreAction;
    var _useState = useState(categories[0] ? categories[0].id : null),
      _useState2 = _slicedToArray(_useState, 2),
      activeTabId = _useState2[0],
      setActiveTabId = _useState2[1];
    var selectedTab = categories.find(function (tab) {
      return tab.id === activeTabId;
    });
    var isExplorerTheme = layoutTheme === EXPLORER_THEME;
    var isLegendTheme = layoutTheme === LEGEND_THEME;
    var isOtherTheme = !isExplorerTheme && !isLegendTheme;
    var isMobile = deviceType === 'mobile';
    var isDesktop = deviceType === 'desktop';
    var addTrackUrl = function addTrackUrl(baseUrl) {
      var encodedPlaceholder = '%7Btracking_id%7D';
      var encodedTrackingId = encodeURIComponent(trackingId !== null && trackingId !== void 0 ? trackingId : "");
      return baseUrl.replace(encodedPlaceholder, encodedTrackingId);
    };
    if (newViewMoreAction && newViewMoreAction.target) {
      newViewMoreAction.target = addTrackUrl(newViewMoreAction.target);
    }
    var sectionHeaderClassName = classNames('section-header-products-gallery', "section-header section-header__".concat(display), {
      'section-header__title-container': hasCategory
    });
    var rowContainerClassName = classNames('row container ui-ms-products-gallery__container', {
      'highlight-seeds': highlightSeeds
    });
    var categoriesClassName = classNames("ui-ms-products-gallery-section ui-ms-products-gallery-section--".concat(layoutTheme, " ui-ms-products-gallery-section--").concat(deviceType), {
      'section-center': hasCategory,
      'ui-ms-section-eshops': isEshopType,
      'ui-ms-section-eshops--seller': eshopType === 'seller' || eshopType === 'brand' || eshopType === 'landing',
      'ui-ms-products-gallery__polycard': isPolycard,
      'ui-ms-products-gallery__polycard--editable': isEditable && isPolycard
    });
    var titleClassName = classNames('products-gallery-title', 'section-header__title--base', {
      'section-header__title': hasCategory
    });
    var eshopContainerClassName = classNames('section-eshop__title--layout', {
      'section-eshop__title': hasCategory
    });
    var NewAction = function NewAction(props) {
      var isMobileDevice = isMobile && usingChevron;
      if (isMobileDevice) {
        return /*#__PURE__*/React.createElement(Action, _extends({}, props, {
          label: null,
          isSelf: true
        }), _ChevronRight || (_ChevronRight = /*#__PURE__*/_createRawReactElement$1(Asset$1, {})));
      }
      return /*#__PURE__*/React.createElement(Action, _extends({}, props, {
        isSelf: true
      }));
    };
    var handleTabs = function handleTabs(event, category) {
      var clickedTabId = event.currentTarget.getAttribute('id');
      setActiveTabId(clickedTabId);
      updateGrid(category);
    };
    var renderChevronRight = function renderChevronRight() {
      var renderIcon = false;
      if (isLegendTheme) {
        renderIcon = true;
      }
      if (isOtherTheme && isMobile) {
        renderIcon = true;
      }
      return renderIcon;
    };
    var renderAction = function renderAction() {
      var _selectedTab$view_mor, _selectedTab$view_mor2;
      var actionComponent = _Fragment || (_Fragment = /*#__PURE__*/React.createElement(React.Fragment, null));
      var label = selectedTab === null || selectedTab === void 0 || (_selectedTab$view_mor = selectedTab.view_more_action) === null || _selectedTab$view_mor === void 0 ? void 0 : _selectedTab$view_mor.label;
      var target = selectedTab === null || selectedTab === void 0 || (_selectedTab$view_mor2 = selectedTab.view_more_action) === null || _selectedTab$view_mor2 === void 0 ? void 0 : _selectedTab$view_mor2.target;
      if (!isEshops) {
        actionComponent = /*#__PURE__*/_createRawReactElement$1("div", {
          className: "".concat(namespace, "-action")
        }, void 0, /*#__PURE__*/_createRawReactElement$1("a", {
          className: "".concat(namespace, "-action__label"),
          alt: label,
          href: target
        }, void 0, label || '', renderChevronRight() && label && (_ChevronRight2 || (_ChevronRight2 = /*#__PURE__*/_createRawReactElement$1(Asset, {})))));
      }
      return actionComponent;
    };
    var withTabsCategory = hasCategory && !withoutTabsCategory;
    var showTitles = function showTitles() {
      return typeEshop(eshopType) ? _EshopsComponentsTitl || (_EshopsComponentsTitl = /*#__PURE__*/_createRawReactElement$1(EshopsComponentsTitles, {
        title: title,
        showTitle: showTitle,
        deviceType: deviceType,
        titleClassName: titleClassName
      })) : _h || (_h = /*#__PURE__*/_createRawReactElement$1("h2", {
        className: titleClassName
      }, void 0, title));
    };
    return /*#__PURE__*/_createRawReactElement$1(Section, {
      type: type,
      className: categoriesClassName,
      eshopType: eshopType
    }, void 0, /*#__PURE__*/_createRawReactElement$1("div", {
      className: rowContainerClassName
    }, void 0, /*#__PURE__*/_createRawReactElement$1("div", {
      className: isEshopType ? eshopContainerClassName : sectionHeaderClassName
    }, void 0, showTitles(), isEshops && showViewMoreAction && newViewMoreAction && /*#__PURE__*/React.createElement(NewAction, newViewMoreAction)), /*#__PURE__*/_createRawReactElement$1("div", {
      className: "ui-ms-products-gallery__tab-list--container"
    }, void 0, withTabsCategory && /*#__PURE__*/_createRawReactElement$1(TabsList, {
      tabs: categories,
      activeTabId: activeTabId,
      handleTabs: handleTabs,
      type: "recommendations",
      layoutTheme: layoutTheme
    }), (isOtherTheme && isDesktop || isLegendTheme && isDesktop || isExplorerTheme) && renderAction()), children, isMobile && !isExplorerTheme && renderAction()));
  };
  RecommendationsContainer.defaultProps = {
    display: 'original',
    highlight_seeds: false,
    view_more_action: null,
    show_title: true,
    eshopType: '',
    type: '',
    withoutTabsCategory: false,
    categories: [],
    isPolycard: false,
    isEditable: false
  };
  return RecommendationsContainer;
}();
var RecommendationsContainer$1 = RecommendationsContainer;
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
var buildGrid = function buildGrid(items, props, deviceType) {
  var ItemsPerRow = props.items_per_row,
    itemsPerRow = props.itemsPerRow,
    ItemsPerRowMobile = props.items_per_row_mobile,
    itemsPerRowMobile = props.itemsPerRowMobile;
  var currentItemsPerRowDesktop = ItemsPerRow || itemsPerRow;
  var currentItemsPerRowMobile = ItemsPerRowMobile || itemsPerRowMobile;
  var itemsPerRowDeviceType = deviceType === 'desktop' ? currentItemsPerRowDesktop : currentItemsPerRowMobile;
  var lazyLoad = props.lazyLoad,
    restClient = props.restClient,
    isPolycard = props.isPolycard;
  var extendedItems = [];
  if (isPolycard) {
    extendedItems = Array.from(items);
  } else {
    extendedItems = items === null || items === void 0 ? void 0 : items.map(function (item) {
      return _objectSpread2(_objectSpread2({}, item), {}, {
        lazyLoad: lazyLoad,
        restClient: restClient
      });
    });
  }
  var totalRows = Math.floor(extendedItems.length / itemsPerRowDeviceType);
  totalRows += extendedItems.length % itemsPerRowDeviceType > 0 ? 1 : 0;
  var range = totalRows > 0 ? Array.from(Array(totalRows).keys()) : [];
  return range.map(function (i) {
    return extendedItems.slice(i * itemsPerRowDeviceType, itemsPerRowDeviceType + i * itemsPerRowDeviceType);
  });
};
var getCategory = function getCategory(categories, categoryId) {
  return categories.find(function (item) {
    return item.id === categoryId;
  });
};
var getGrid = function getGrid(props, deviceType) {
  var items = props.items,
    categories = props.categories,
    isPolycard = props.isPolycard;
  if (isPolycard) {
    var _getCategory;
    var polycardItems = categories.length ? (_getCategory = getCategory(categories, categories[0].id)) === null || _getCategory === void 0 ? void 0 : _getCategory.polycards : [];
    return buildGrid(polycardItems, props, deviceType);
  }
  var newItems = categories.length ? getCategory(categories, categories[0].id).items : items;
  return buildGrid(newItems, props, deviceType);
};
var useGrid = function useGrid(props, deviceType) {
  var _useState = useState(getGrid(props, deviceType)),
    _useState2 = _slicedToArray(_useState, 2),
    grid = _useState2[0],
    setGrid = _useState2[1];
  var newGrid = function newGrid(categoryId) {
    var items = [];
    if (props !== null && props !== void 0 && props.isPolycard) {
      var _getCategory2;
      items = (_getCategory2 = getCategory(props.categories, categoryId)) === null || _getCategory2 === void 0 ? void 0 : _getCategory2.polycards;
    } else {
      items = getCategory(props.categories, categoryId).items;
    }
    setGrid(buildGrid(items, props, deviceType));
  };
  var reloadGrid = function reloadGrid(newProps) {
    setGrid(getGrid(newProps, deviceType));
  };
  return {
    grid: grid,
    newGrid: newGrid,
    reloadGrid: reloadGrid
  };
};
const ProductsGalleryDesktop = /*#__PURE__*/function () {
  const ProductsGalleryDesktop = function ProductsGalleryDesktop(props) {
    var ItemsPerRow = props.items_per_row,
      itemsPerRow = props.itemsPerRow,
      MaxItems = props.max_items,
      maxItems = props.maxItems,
      display = props.display,
      shippingTitle = props.shippingTitle,
      categories = props.categories,
      items = props.items,
      eshopType = props.eshopType,
      deviceType = props.deviceType,
      ftNewComponentsV2 = props.ftNewComponentsV2,
      isPolycard = props.isPolycard,
      ComponentCard = props.ComponentCard,
      isSupermarketShop = props.isSupermarketShop;
    var itemsPerRowValue = ItemsPerRow || itemsPerRow;
    var maxItemsValue = MaxItems || maxItems;
    var itemsLength = items.length > 0 ? items.length : categories.length > 0 ? categories[0].items.length : 0;
    var _useGrid = useGrid(props, deviceType),
      grid = _useGrid.grid,
      newGrid = _useGrid.newGrid,
      reloadGrid = _useGrid.reloadGrid;
    var updateGrid = function updateGrid(categoryId) {
      newGrid(categoryId);
    };
    useEffect(function () {
      reloadGrid(props);
    }, [maxItemsValue, itemsPerRowValue, categories, items]);
    var seeElementInCard = {
      action_card: !ESHOPS_WITHOUT_CARDACTIONS.includes(eshopType)
    };
    var container = classNames('grid-container', {
      'grid-container__items-per-row-one': itemsPerRowValue < 2,
      'ui-ms-grid-container__eshops': ESHOPS.includes(eshopType),
      'ui-ms-grid-container__eshops--seller': eshopType === 'seller'
    });
    var containerItem = classNames({
      'ui-item-grid__six': itemsLength >= 6 && itemsPerRowValue === 5,
      'ui-item-grid__five': itemsLength >= 5 && itemsPerRowValue === 4,
      'ui-item-grid__four': itemsLength >= 4 && itemsPerRowValue === 3
    });
    var isEshopItem = ESHOPS_WITH_ESHOSITEMS.includes(eshopType);
    return /*#__PURE__*/React.createElement(RecommendationsContainer$1, _extends({}, props, {
      updateGrid: updateGrid
    }), grid.map(function (row) {
      return /*#__PURE__*/_createRawReactElement$1("div", {
        className: container
      }, v4(), row.map(function (item) {
        var isFakeEshopItem = isEshopItem && (item === null || item === void 0 ? void 0 : item.isFakeCard);
        var isRegularEshopItem = isEshopItem && !isPolycard;
        if ((isRegularEshopItem || isFakeEshopItem) && EshopItem) {
          return /*#__PURE__*/_createRawReactElement$1(EshopItem, {
            item: item,
            deviceType: deviceType,
            seeElements: seeElementInCard,
            eshopType: eshopType,
            isSupermarketShop: isSupermarketShop
          }, v4());
        }
        if (isPolycard && ComponentCard) {
          var _item$metadata;
          return /*#__PURE__*/_createRawReactElement$1(ComponentCard, {
            polycard: item
          }, item === null || item === void 0 || (_item$metadata = item.metadata) === null || _item$metadata === void 0 ? void 0 : _item$metadata.id);
        }
        return /*#__PURE__*/React.createElement(ItemDesktop, _extends({}, item, {
          key: v4(),
          display: display,
          shippingTitle: shippingTitle,
          itemsPerRow: itemsPerRowValue,
          ftNewComponentsV2: ftNewComponentsV2,
          className: containerItem,
          deviceType: deviceType
        }));
      }));
    }));
  };
  ProductsGalleryDesktop.defaultProps = {
    display: 'original',
    shippingTitle: '',
    lazyLoad: 'on',
    withoutTabsCategory: false,
    eshopType: '',
    categories: [],
    ftNewComponentsV2: false,
    isPolycard: false,
    isSupermarketShop: false
  };
  return ProductsGalleryDesktop;
}();
var ProductsGalleryDesktop$1 = ProductsGalleryDesktop;
const ProductsGalleryMobile = /*#__PURE__*/function () {
  const ProductsGalleryMobile = function ProductsGalleryMobile(props) {
    var actionButton = props.action_button,
      ItemsPerRowMobile = props.items_per_row_mobile,
      itemsPerRowMobile = props.itemsPerRowMobile,
      MaxItemsMobile = props.max_items_mobile,
      maxItemsMobile = props.maxItemsMobile,
      display = props.display,
      shippingTitle = props.shippingTitle,
      categories = props.categories,
      items = props.items,
      lazyLoad = props.lazyLoad,
      eshopType = props.eshopType,
      deviceType = props.deviceType,
      ftNewComponentsV2 = props.ftNewComponentsV2,
      isPolycard = props.isPolycard,
      ComponentCard = props.ComponentCard,
      isSupermarketShop = props.isSupermarketShop;
    var itemsPerRowValue = ItemsPerRowMobile || itemsPerRowMobile;
    var maxItemsValue = MaxItemsMobile || maxItemsMobile;
    var _useGrid = useGrid(props, deviceType),
      grid = _useGrid.grid,
      newGrid = _useGrid.newGrid,
      reloadGrid = _useGrid.reloadGrid;
    var updateGrid = function updateGrid(category) {
      newGrid(category);
    };
    var seeElementInCard = {
      action_card: !ESHOPS_WITHOUT_CARDACTIONS.includes(eshopType)
    };
    useEffect(function () {
      reloadGrid(props);
    }, [maxItemsValue, itemsPerRowValue, categories, items]);
    var classNameContainer = classNames('grid-container', {
      'ui-ms-grid-container__eshops': ESHOPS.includes(eshopType),
      'ui-ms-grid-container__eshops--seller': eshopType === 'seller'
    });
    var isEshopItem = ESHOPS_WITH_ESHOSITEMS.includes(eshopType);
    return /*#__PURE__*/React.createElement(RecommendationsContainer$1, _extends({}, props, {
      updateGrid: updateGrid
    }), grid.map(function (row) {
      return /*#__PURE__*/_createRawReactElement$1("div", {
        className: classNameContainer
      }, v4(), row.map(function (item) {
        var isFakeEshopItem = isEshopItem && (item === null || item === void 0 ? void 0 : item.isFakeCard);
        var isRegularEshopItem = isEshopItem && !isPolycard;
        if ((isRegularEshopItem || isFakeEshopItem) && EshopItem) {
          return /*#__PURE__*/_createRawReactElement$1(EshopItem, {
            item: item,
            deviceType: deviceType,
            seeElements: seeElementInCard,
            eshopType: eshopType,
            isSupermarketShop: isSupermarketShop
          }, v4());
        }
        if (isPolycard && ComponentCard) {
          var _item$metadata;
          return /*#__PURE__*/_createRawReactElement$1(ComponentCard, {
            polycard: item
          }, item === null || item === void 0 || (_item$metadata = item.metadata) === null || _item$metadata === void 0 ? void 0 : _item$metadata.id);
        }
        return /*#__PURE__*/React.createElement(ItemMobile, _extends({}, item, {
          key: v4(),
          display: display,
          lazyLoad: lazyLoad,
          "data-testid": "item-component",
          shippingTitle: shippingTitle,
          itemsPerRow: itemsPerRowValue,
          ftNewComponentsV2: ftNewComponentsV2,
          deviceType: deviceType
        }));
      }));
    }), actionButton && /*#__PURE__*/_createRawReactElement$1(Button, {
      id: actionButton.id,
      className: "grid-recommendations-button",
      href: actionButton.target
    }, void 0, actionButton.label));
  };
  ProductsGalleryMobile.defaultProps = {
    display: 'original',
    shippingTitle: '',
    lazyLoad: 'on',
    withoutTabsCategory: false,
    eshopType: '',
    categories: [],
    ftNewComponentsV2: false,
    itemsPerRowMobile: 0,
    items_per_row_mobile: 0,
    maxItemsMobile: 0,
    max_items_mobile: 0,
    isPolycard: false,
    isSupermarketShop: false
  };
  return ProductsGalleryMobile;
}();
var ProductsGalleryMobile$1 = ProductsGalleryMobile;
export { ProductsGalleryDesktop$1 as ProductsGalleryDesktop, ProductsGalleryMobile$1 as ProductsGalleryMobile, ProductsGalleryV3$1 as ProductsGalleryV3 };
